'use strict';

const jQuery = require('jquery');
const mediator = require('./../core/mediator');

require('jquery-ui/ui/widgets/autocomplete');

jQuery.fn.publish = function(eventName, params, domEvent) {
    let current = jQuery(this);

    current.on(domEvent || 'click', function(eventName, params, event) {
        params = params || {};

        params.event = event;

        mediator.publish(eventName, params);
    }.bind(current, eventName, params));
};

jQuery.ui.autocomplete.prototype._resizeMenu = function() {
    this.menu.element.outerWidth(this.element.outerWidth());
};
